// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/nurse-bg-1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nurse-consultant-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
 background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden; /* ✅ Prevent horizontal scroll */
  display: flex;
  flex-direction: column;
}

.nurse-consultant-wrapper {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 100px 20px 60px 20px; */
}

.nurse-consultant-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 50px;
  max-width: 850px;
  width: 100%;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.nurse-consultant-title {
  font-size: 2rem;
  font-weight: 700;
  color: #c01313;
  margin-bottom: 10px;
}

.nurse-consultant-subtitle {
  font-size: 1rem;
  color: #333;
  margin-bottom: 35px;
}

iframe {
  width: 100%;
  border: none;
  min-height: 1100px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .nurse-consultant-container {
    padding: 30px 20px;
  }

  .nurse-consultant-title {
    font-size: 1.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ApplyNurseConsultant.css"],"names":[],"mappings":"AAAA;EACE,yDAAoD;CACrD,qBAAqB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,kBAAkB,EAAE,gCAAgC;EACpD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".nurse-consultant-page {\n  background-image: url(\"../../public/nurse-bg-1.jpg\");\n background-size: auto;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  width: 100%;\n  overflow-x: hidden; /* ✅ Prevent horizontal scroll */\n  display: flex;\n  flex-direction: column;\n}\n\n.nurse-consultant-wrapper {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* padding: 100px 20px 60px 20px; */\n}\n\n.nurse-consultant-container {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 16px;\n  padding: 50px;\n  max-width: 850px;\n  width: 100%;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.nurse-consultant-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #c01313;\n  margin-bottom: 10px;\n}\n\n.nurse-consultant-subtitle {\n  font-size: 1rem;\n  color: #333;\n  margin-bottom: 35px;\n}\n\niframe {\n  width: 100%;\n  border: none;\n  min-height: 1100px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n}\n\n@media (max-width: 768px) {\n  .nurse-consultant-container {\n    padding: 30px 20px;\n  }\n\n  .nurse-consultant-title {\n    font-size: 1.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
